import React, { useState, useEffect } from "react";
import Sidebar from "../Components/Sidebar/Sidebar";
import BootstrapTable from "react-bootstrap-table-next";
import pagination from "./pagination";
import "./Stax.css";
import { Roller } from "react-awesome-spinners";
import {
  getreminder,
  getuserdataapi,
  reminder,
  updateReminder,
  getemailmessages,
  deleteemaildata,
  testsendemail
} from "../Api/crm";
import Spinner from "react-bootstrap/Spinner";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { ReminderSelector } from "./ReminderSelector";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
function EmailBuilder() {
  const [showReminder, setShowReminder] = useState(false);
  const [unit, setUnit] = useState("Days");
  const [value, setValue] = useState(1);

  const [loading, setLoading] = useState(false);
  const [emailData, setEmailData] = useState([]);
  const [emailid, setEmailId] = useState("");
  const [emailfilename, setEmailFilename] = useState("");
  const getuserdata = () => {
    setLoading(true);
    getemailmessages()
      .then((response) => {
        if (response.code === 200) {
          const apiResponse = response.data;

          // Check if the API status is success
          if (apiResponse.status === 1) {
            const fetchedMargedata = apiResponse.data;
            setEmailData(fetchedMargedata);
          } else {
            setEmailData([]);
          }
        } else {
          setEmailData([]);
        }
      })
      .catch(function (err) {
        // Handle network or unexpected errors
        console.error("Error fetching data:", err);
        setEmailData([]);
      })
      .finally(() => {
        // Hide the loading spinner after the request completes
        setLoading(false);
      });
  };
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [orderId, setOrderId] = useState(0);
  const [email, setEmail] = useState("");

  const handleConfirm = () => {
    setShow(false);

    // Perform the delete action here
    const formdata = new FormData();
    formdata.append("filename", emailid);

    deleteemaildata(formdata)
      .then((res) => {
        if (res.code === 200) {
          getuserdata();
        } else {
          alert("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        getuserdata();
      });
  };

  const [testemailLoader, settestEmailLoader] = useState(false);

  const sendtestEmail = () => {
    settestEmailLoader(true);
    const formdata = new FormData();
    formdata.append("filename", emailfilename);
    formdata.append("order_id", orderId);
    formdata.append("email", email);

    testsendemail(formdata)
      .then((res) => {
        if (res.code === 200) {
          settestEmailLoader(false);
          alert("Test email sent successfully");
          setShow3(false);
          setEmail("");
          setOrderId(0);
        } else {
          settestEmailLoader(false);
          console.log("Something went wrong");
        }
      })
      .catch((error) => {
        settestEmailLoader(false);
        console.log(error);
      });
  };

  useState(() => {
    getuserdata();
  }, []);
  const radioOptions = [
    {
      name: "Welcome Email",
      label: "Welcome Email",
      id: "01_welcome_email.html",
    },
    {
      name: "Booking Confirmation Email",
      label: "Booking Confirmation Email",
      id: "02_booking_confirmation.html",
    },
    {
      name: "Booking Reminder Email",
      label: "Booking Reminder Email",
      id: "03_booking_reminder.html",
    },
    {
      name: "Service Thank You Email",
      label: "Service Thank You Email",
      id: "04_service_thank_you.html",
    },
    {
      name: "Follow Up Review Email",
      label: "Follow Up Review Email",
      id: "05_follow_up_review.html",
    },
    {
      name: "Offer Discount Email",
      label: "Offer Discount Email",
      id: "06_offer_discount.html",
    },
    {
      name: "Re-engagement Email",
      label: "Re-engagement Email",
      id: "07_reengagement_email.html",
    },
    {
      name: "Cancellation Confirmation Email",
      label: "Cancellation Confirmation Email",
      id: "08_cancellation_confirmation.html",
    },
    {
      name: "Daily Schedule Email (Staff)",
      label: "Daily Schedule Email (Staff)",
      id: "09_daily_schedule_staff.html",
    },
    {
      name: "Shift Reminder Email (Staff)",
      label: "Shift Reminder Email (Staff)",
      id: "10_shift_reminder_staff.html",
    },
    {
      name: "Policy Update Email",
      label: "Policy Update Email",
      id: "11_policy_update_staff.html",
    },
    {
      name: "Payslip Info Email",
      label: "Payslip Info Email",
      id: "12_payslip_info.html",
    },
    {
      name: "Reset Password Email",
      label: "Reset Password Email",
      id: "13_reset_password.html",
    },
    {
      name: "Invoice Email",
      label: "Invoice Email",
      id: "14_invoice_email.html",
    },
    {
      name: "Account Confirmation Email",
      label: "Account Confirmation Email",
      id: "15_account_confirmation.html",
    },
    {
      name: "Subscription Renewal Email",
      label: "Subscription Renewal Email",
      id: "16_subscription_renewal.html",
    },
    { name: "Default Template", label: "Default Template", id: "17" },
  ];
  // 5 reminders → each has its own unit & value
  const [unit1, setUnit1] = useState("");
  const [value1, setValue1] = useState("0");
  const [disabled_reminder1, setDisabledReminder1] = useState(false);

  const [unit2, setUnit2] = useState("");
  const [value2, setValue2] = useState("0");
  const [disabled_reminder2, setDisabledReminder2] = useState(false);

  const [unit3, setUnit3] = useState("");
  const [value3, setValue3] = useState("0");
  const [disabled_reminder3, setDisabledReminder3] = useState(false);

  const [unit4, setUnit4] = useState("");
  const [value4, setValue4] = useState("0");
  const [disabled_reminder4, setDisabledReminder4] = useState(false);

  const [unit5, setUnit5] = useState("");
  const [value5, setValue5] = useState("0");
  const [disabled_reminder5, setDisabledReminder5] = useState(false);
  const [loadingReminder, setLoadingReminder] = useState(false);
  const [reminderData, setReminderData] = useState([]);

  const handleSaveReminder = async () => {
    setLoadingReminder(true);

    const checkStage = (value, unit, status, stageNumber) => {
      const isStageEnabled = value || unit || status;
      if (isStageEnabled) {
        if (!value || !unit || !status) {
          NotificationManager.error(
            `Please fill all fields for reminder stage ${stageNumber}`
          );
          return false;
        }
      }
      return true;
    };

    if (
      !checkStage(value1, unit1, disabled_reminder1, 1) ||
      !checkStage(value2, unit2, disabled_reminder2, 2) ||
      !checkStage(value3, unit3, disabled_reminder3, 3) ||
      !checkStage(value4, unit4, disabled_reminder4, 4) ||
      !checkStage(value5, unit5, disabled_reminder5, 5)
    ) {
      setLoadingReminder(false);
      return;
    }

    const formData = new FormData();
    formData.append("filename", emailfilename);

    const appendStage = (value, unit, status, stageNumber) => {
      if (value && unit && status) {
        // Only append fully filled stages
        formData.append(`reminder_stage_${stageNumber}`, stageNumber);
        formData.append(`reminder_value_${stageNumber}`, value);
        formData.append(`reminder_type_${stageNumber}`, unit);
        formData.append(`reminder_status_${stageNumber}`, status);
      }
    };

    appendStage(value1, unit1, disabled_reminder1, 1);
    appendStage(value2, unit2, disabled_reminder2, 2);
    appendStage(value3, unit3, disabled_reminder3, 3);
    appendStage(value4, unit4, disabled_reminder4, 4);
    appendStage(value5, unit5, disabled_reminder5, 5);

    const apiCall = reminderData.length > 0 ? updateReminder : reminder;

    try {
      const res = await apiCall(formData);
      if (res.code === 200) {
        NotificationManager.success(res.data?.message);
        setShowReminder(false);
        handleGetReminder(emailfilename);
      } else {
        NotificationManager.error(res.data?.message);
      }
    } catch (error) {
      NotificationManager.error(error?.message);
    } finally {
      setLoadingReminder(false);
    }
  };

  const handleGetReminder = async (filename) => {
    setLoadingReminder(true);
    try {
      const res = await getreminder(filename);

      if (res.code === 200) {
        const data = res?.data.data || [];
        setReminderData(data);

        // Find each stage reminder
        const firstUnit = data.find((item) => item.reminder_stage === "1");
        const secondUnit = data.find((item) => item.reminder_stage === "2");
        const thirdUnit = data.find((item) => item.reminder_stage === "3");
        const fourthUnit = data.find((item) => item.reminder_stage === "4");
        const fifthUnit = data.find((item) => item.reminder_stage === "5");

        // Set state safely
        setUnit1(firstUnit?.reminder_type || "");
        setValue1(firstUnit?.reminder_value || "");
        setDisabledReminder1(firstUnit?.reminder_status === "true");

        setUnit2(secondUnit?.reminder_type || "");
        setValue2(secondUnit?.reminder_value || "");
        setDisabledReminder2(secondUnit?.reminder_status === "true");

        setUnit3(thirdUnit?.reminder_type || "");
        setValue3(thirdUnit?.reminder_value || "");
        setDisabledReminder3(thirdUnit?.reminder_status === "true");

        setUnit4(fourthUnit?.reminder_type || "");
        setValue4(fourthUnit?.reminder_value || "");
        setDisabledReminder4(fourthUnit?.reminder_status === "true");

        setUnit5(fifthUnit?.reminder_type || "");
        setValue5(fifthUnit?.reminder_value || "");
        setDisabledReminder5(fifthUnit?.reminder_status === "true");

      } else {
        NotificationManager.error(res?.message);
      }
    } catch (error) {
      NotificationManager.error(error?.message);
    } finally {
      setLoadingReminder(false);
    }
  };

  useEffect(() => {
    if (emailfilename) {
      // handleGetReminder(emailfilename);
    }
  }, [emailfilename]);
  if (loading) {
    return <div className="card-body table-card-body">Loading...</div>;
  }
  const handleReset = () => {
    setUnit1("");
    setDisabledReminder1(false);
    setValue1(0);
    setUnit2("");
    setDisabledReminder2(false);
    setValue2(0);
    setUnit3("");
    setDisabledReminder3(false);
    setValue3(0);
    setUnit4("");
    setDisabledReminder4(false);
    setValue4(0);
    setUnit5("");
    setDisabledReminder5(false);
    setValue5(0);
  };
const handleToggle1 = () => {
  const newVal = !disabled_reminder1;
  setDisabledReminder1(newVal);

  if (!newVal) {  // when disabled → clear fields
    setValue1("");
    setUnit1("");
  }
};

const handleToggle2 = () => {
  const newVal = !disabled_reminder2;
  setDisabledReminder2(newVal);
  if (!newVal) {
    setValue2("");
    setUnit2("");
  }
};

const handleToggle3 = () => {
  const newVal = !disabled_reminder3;
  setDisabledReminder3(newVal);
  if (!newVal) {
    setValue3("");
    setUnit3("");
  }
};

const handleToggle4 = () => {
  const newVal = !disabled_reminder4;
  setDisabledReminder4(newVal);
  if (!newVal) {
    setValue4("");
    setUnit4("");
  }
};

const handleToggle5 = () => {
  const newVal = !disabled_reminder5;
  setDisabledReminder5(newVal);
  if (!newVal) {
    setValue5("");
    setUnit5("");
  }
};

  return (
    <div>
      {/* Delete Modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to proceed with this action?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show2} onHide={handleClose2}>
        <Modal.Header closeButton>
          <Modal.Title>Choose your templates</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {radioOptions.map((option) => (
              <div key={option.id} className="mb-2">
                <Form.Check
                  type="radio"
                  id={option.id}
                  name="emailTemplate"
                  label={option.label}
                  value={option.id}
                  onChange={(e) => {
                    setEmailId(e.target.id);
                  }}
                />
              </div>
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose2}>
            Cancel
          </Button>
          <Link to={`/add-email-builder?template=${emailid}`}>
            <Button variant="danger">Confirm</Button>
          </Link>
        </Modal.Footer>
      </Modal>

      <Modal show={show3} onHide={handleClose3}>
        <Modal.Header closeButton>
          <Modal.Title>Enter Your Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId="formName" className="mt-2">
              <Form.Label>Booking ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your Booking ID"
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose3}>
            Cancel
          </Button>
          {testemailLoader ? (
            <Button variant="primary" disabled>
              Sending...
            </Button>
          ) : (
            <Button variant="danger" onClick={sendtestEmail}>
              Confirm
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showReminder}
        onHide={() => setShowReminder(false)}
        className="Sidebar-Modal-end"
      >
        <Modal.Header
          className="d-flex justify-content-between align-items-center"
          closeButton
        >
          <Modal.Title>Set Reminder</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex justify-content-end">
            {/* Reset Button */}
            <Button variant="outline-primary" size="sm" onClick={handleReset}>
              Reset
            </Button>
          </div>
          <ReminderSelector
            label="Send First Reminder Before"
            unit={unit1}
            setUnit={setUnit1}
            value={value1}
            setValue={setValue1}
            disabled={disabled_reminder1}
            setDisabled={handleToggle1}
          />

          <ReminderSelector
            label="Send Second Reminder Before"
            unit={unit2}
            setUnit={setUnit2}
            value={value2}
            setValue={setValue2}
            disabled={disabled_reminder2}
            setDisabled={handleToggle2}
          />

          <ReminderSelector
            label="Send Third Reminder Before"
            unit={unit3}
            setUnit={setUnit3}
            value={value3}
            setValue={setValue3}
            disabled={disabled_reminder3}
            setDisabled={handleToggle3}
          />

          <ReminderSelector
            label="Send Fourth Reminder Before"
            unit={unit4}
            setUnit={setUnit4}
            value={value4}
            setValue={setValue4}
            disabled={disabled_reminder4}
            setDisabled={handleToggle4}
          />

          <ReminderSelector
            label="Send Fifth Reminder Before"
            unit={unit5}
            setUnit={setUnit5}
            value={value5}
            setValue={setValue5}
            disabled={disabled_reminder5}
            setDisabled={handleToggle5}
          />
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-end">
          <Button
    className="Active-bttn btn"
    onClick={() => {handleSaveReminder()}}
  >
    {loadingReminder ? <Spinner animation="border" /> : "Save"}
  </Button>
        </Modal.Footer>
        <style>{`
             .scroll-picker {
            width: 100px;
            height: 120px;
            overflow-y: scroll;
            scrollbar-width: none;
            -ms-overflow-style: none;
            }

            .scroll-picker::-webkit-scrollbar {
            display: none;
            }

            .picker-select {
            width: 100%;
            height: 120px;
            font-size: 18px;
            padding: 40px 0;
            text-align: center;
            border: none;
            background: transparent;
            }

      
      `}</style>
      </Modal>

      <div className="dashboard-container d-flex">
        <div className="sidebar-container">
          <Sidebar />
        </div>
        <div className="main-container">
          <div className="main-page-body-content">
            <div className="main-page-body-content-body">
              <div className="main-page-body-content-body-container">
                <div className="container-fulid">
                  <div className="">
                    <div className="table-card ">
                      <div className="card-body table-card-body">
                        <div className="table-card-header">
                          <h5 className="card-title">Email BuilderS</h5>
                        </div>
                        <div className="table-card-body-inner">
                          <div className="animated fadeIn">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="card">
                                  <div className="card-header d-flex justify-content-between table-card-header">
                                    <div className="card-header d-flex table-card-header justify-content-between align-items-center">
                                      <div className="ml-auto d-flex">
                                        <button
                                          onClick={handleShow2}
                                          className="btn d-flex align-items-center justify-content-center btn-success"
                                        >
                                          Add Email
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-body">
                                    <Table striped bordered hover>
                                      <thead>
                                        <tr>
                                          <th>Id</th>
                                          <th>Email subject</th>
                                          <th>Created Date</th>
                                          <th>Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {emailData ? (
                                          emailData.map((item, index) => {
                                            const currentUserIndex = index + 1;
                                            return (
                                              <tr key={index}>
                                                <td>{currentUserIndex}</td>
                                                <td>{item.subject}</td>
                                                <td>{item.created_at}</td>
                                                <td>
                                                  <Link
                                                    to={`/email-builder-view/${item.filename}`}
                                                    className="btn btn-info me-2"
                                                  >
                                                    View
                                                  </Link>
                                                  {/* <button onClick={() => {
                                                                                                        handleShow();
                                                                                                        setEmailId(item.filename)
                                                                                                    }} className="btn btn-danger me-2">Delete</button> */}
                                                  <button
                                                    onClick={() => {
                                                      handleShow3();
                                                      setEmailFilename(
                                                        item.filename
                                                      );
                                                    }}
                                                    className="btn btn-warning me-2"
                                                  >
                                                    Test
                                                  </button>
                                                  <Button
                                                    className="btn btn-danger"
                                                    onClick={() => {
                                                      setShowReminder(true);
                                                      setEmailFilename(
                                                        item.filename
                                                      );
                                                    }}
                                                  >
                                                    Set Reminder
                                                  </Button>
                                                </td>
                                              </tr>
                                            );
                                          })
                                        ) : (
                                          <tr>
                                            <td colSpan="4">No Data Found</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <NotificationContainer />
    </div>
  );
}

export default EmailBuilder;
